import { cva } from '@/styled-system/css';

export const filterChipWithMenuSelectRecipe = cva({
  base: {
    appearance: 'none',
    maxWidth: '100%',
    position: 'relative',
    textOverflow: 'ellipsis',
    width: 'auto',
    backgroundImage: {
      base: `url("data:image/svg+xml,%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%23111116%22%20d%3D%22M14.7%205.3a1%201%200%200%200-1.4%200L8%2010.6%202.7%205.3a1%201%200%201%200-1.4%201.4l6%206a1%201%200%200%200%201.4%200l6-6a1%201%200%200%200%200-1.4Z%22%2F%3E%3C%2Fsvg%3E")`,
      _dark: `url("data:image/svg+xml,%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M14.7%205.3a1%201%200%200%200-1.4%200L8%2010.6%202.7%205.3a1%201%200%201%200-1.4%201.4l6%206a1%201%200%200%200%201.4%200l6-6a1%201%200%200%200%200-1.4Z%22%2F%3E%3C%2Fsvg%3E")`,
    },
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right {spacing.Chip.padding.horz} center',
    paddingInlineEnd: 'calc({spacing.Chip.padding.horz} + {spacing.tighter} + {sizes.icon.sm})',
    color: 'text.neutral',
    textStyle: 'body-sm-bold',
  },
  variants: {
    disabled: {
      true: {},
      false: {
        _after: {
          content: '""',
          position: 'absolute',
          height: 'tapArea.mobile.sm',
          minWidth: 'tapArea.mobile.sm',
          width: '100%',
          left: '0',
          top: '50%',
          marginTop: 'calc(({sizes.tapArea.mobile.sm} / 2) * -1)',
        },
      },
    },
  },
});
